var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationStatus2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2104 27.8901C32.5742 29.3946 31.5792 30.7203 30.3123 31.7514C29.0454 32.7825 27.5452 33.4875 25.9428 33.8048C24.3405 34.1222 22.6848 34.0422 21.1205 33.5719C19.5563 33.1015 18.131 32.2551 16.9694 31.1067C15.8078 29.9583 14.9452 28.5428 14.457 26.984C13.9689 25.4252 13.87 23.7706 14.169 22.1647C14.468 20.5589 15.1559 19.0507 16.1724 17.7721C17.189 16.4935 18.5033 15.4834 20.0004 14.8301M33.2392 20.1732C33.6395 21.1397 33.8851 22.1614 33.9684 23.2009C33.989 23.4577 33.9993 23.5861 33.9483 23.7018C33.9057 23.7984 33.8213 23.8898 33.7284 23.94C33.6172 24.0001 33.4783 24.0001 33.2004 24.0001H24.8004C24.5204 24.0001 24.3804 24.0001 24.2734 23.9456C24.1793 23.8976 24.1028 23.8211 24.0549 23.7271C24.0004 23.6201 24.0004 23.4801 24.0004 23.2001V14.8001C24.0004 14.5222 24.0004 14.3833 24.0605 14.2721C24.1107 14.1791 24.2021 14.0948 24.2987 14.0522C24.4144 14.0012 24.5428 14.0115 24.7996 14.0321C25.839 14.1154 26.8608 14.361 27.8272 14.7613C29.0405 15.2638 30.1429 16.0004 31.0715 16.929C32.0001 17.8576 32.7367 18.96 33.2392 20.1732Z",
    stroke: "#166534",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatus2);
export default __webpack_public_path__ + "static/media/applicationStatus2.f19c3e4e56ced4cf173734cdcbb0b1c4.svg";
export { ForwardRef as ReactComponent };